export default __webpack_public_path__ + "static/media/01.8a638f81.png";